import {
  FETCH_COMMUNITY_PROFILE_SUCCESS,
  FETCH_COMMUNITY_PROFILE_FAILURE,
  UPDATE_COMMUNITY_PROFILE_SUCCESS,
  COMMUNITY_SET_IS_LOADING,
  FETCH_SUGGESTED_GROUPS_REQUEST,
  FETCH_SUGGESTED_GROUPS_SUCCESS,
  FETCH_SUGGESTED_GROUPS_FAILURE,
  FETCH_MY_GROUPS_REQUEST,
  FETCH_MY_GROUPS_SUCCESS,
  FETCH_MY_GROUPS_FAILURE,
  REMOVE_MY_GROUP,
  ADD_MY_GROUP,
  REMOVE_SUGGESTED_GROUP,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  REMOVE_NOTIFICATION,
  UPDATE_NOTIFICATION_READ,
  UPDATE_ALL_NOTIFICATIONS_READ,
  CLEAR_ALL_NOTIFICATIONS,
} from '../../constant/community';
import { RESET_STORE } from '../../constant/common';

const initialState = {
  isLoading: false,
  profile: null,
  error: null,
  suggestedGroups: [],
  suggestedGroupsMeta: null,
  isSuggestedGroupsLoading: false,
  myGroups: [],
  myGroupsMeta: null,
  isMyGroupsLoading: false,
  notifications: [],
  notificationsMeta: null,
  isNotificationsLoading: false,
};

export const communityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMMUNITY_SET_IS_LOADING:
      return { ...state, isLoading: payload };
    case FETCH_COMMUNITY_PROFILE_SUCCESS:
      return { ...state, profile: payload, error: null };
    case FETCH_COMMUNITY_PROFILE_FAILURE:
      return { ...state, error: payload };
    case UPDATE_COMMUNITY_PROFILE_SUCCESS:
      return { ...state, profile: payload };
    case FETCH_SUGGESTED_GROUPS_REQUEST:
      return { ...state, isSuggestedGroupsLoading: true };
    case FETCH_SUGGESTED_GROUPS_SUCCESS:
      return {
        ...state,
        isSuggestedGroupsLoading: false,
        suggestedGroups:
          payload.page === 1
            ? payload.data
            : [...state.suggestedGroups, ...payload.data],
        suggestedGroupsMeta: payload.meta,
      };
    case FETCH_SUGGESTED_GROUPS_FAILURE:
      return { ...state, isSuggestedGroupsLoading: false };
    case FETCH_MY_GROUPS_REQUEST:
      return { ...state, isMyGroupsLoading: true };
    case FETCH_MY_GROUPS_SUCCESS:
      return {
        ...state,
        isMyGroupsLoading: false,
        myGroups:
          payload.page === 1
            ? payload.data
            : [...state.myGroups, ...payload.data],
        myGroupsMeta: payload.meta,
      };
    case FETCH_MY_GROUPS_FAILURE:
      return { ...state, isMyGroupsLoading: false };
    case REMOVE_MY_GROUP:
      return {
        ...state,
        myGroups: state.myGroups.filter(g => g.id !== payload),
      };
    case ADD_MY_GROUP:
      return {
        ...state,
        myGroups: state.myGroups.some(g => g.id === payload.id)
          ? state.myGroups
          : [payload, ...state.myGroups],
      };
    case REMOVE_SUGGESTED_GROUP:
      return {
        ...state,
        suggestedGroups: state.suggestedGroups.filter(g => g.uuid !== payload),
      };
    case FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, isNotificationsLoading: true };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isNotificationsLoading: false,
        notifications:
          payload.page === 1
            ? payload.data
            : [...state.notifications, ...payload.data],
        notificationsMeta: payload.meta,
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return { ...state, isNotificationsLoading: false };
    case REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(n => n.id !== payload),
      };
    case UPDATE_NOTIFICATION_READ:
      return {
        ...state,
        notifications: state.notifications.map(n =>
          n.id === payload ? { ...n, is_read: true } : n,
        ),
      };
    case UPDATE_ALL_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: state.notifications.map(n => ({ ...n, is_read: true })),
      };
    case CLEAR_ALL_NOTIFICATIONS:
      return { ...state, notifications: [], notificationsMeta: null };
    case RESET_STORE:
      return { ...initialState };
    default:
      return state;
  }
};
